const moment = require('moment');
require('backbone.stickit');

// update($el, val, model, options) is the function that updates the view from the model.
// getVal($el, event, options) is the function that gets the value from the view binding and updates the model.
// Don't override either the update or getVal event handlers, unless you find you must.
// Don't override the events property, unless you find you must.

let datePickerHandler = {
    selector: '.datePicker',
    events: ['dp.change'],
    update: function ($el, val) {
        let datePicker = $el.data('DateTimePicker');
        if (val && datePicker) {
            let date = moment(val);
            datePicker.date(date);
            if (datePicker.format() === 'MM/YYYY') {
                $el.val(val);
            }
            else {
                $el.val(date.format(datePicker.format()));
            }
        }
        else if (datePicker && !val) {
            datePicker.clear();
        }
        else {
            $el.val(val);
        }
        
    },
    getVal: function ($el) {
        let date = $el.data('DateTimePicker').date(),
            format = $el.data('DateTimePicker').format() || 'YYYY-MM-DDTHH:mm';
        return date ? date.format(format) : '';
    }
};

let checkboxButtonHandler = {
    selector: '[data-button-type="checkbox"]',
    update: function ($el, val, model, options) {
        if (val) {
            $el.parent().addClass('active');
            $el.parent().addClass('btn-info');
        } else {
            $el.parent().removeClass('active');
            $el.parent().removeClass('btn-info');
        }
    },
    getVal: function ($el, event, options) {
        // This handler code was copied directly from source, then modified.
        let val;
        if ($el.length > 1) {
            // Multiple checkboxes bound to single model property.
            // JB:
            // For now, I'm not sure this would really work with how we wanna
            // use bootstrap button toggles.  It could work, I'm sure, but it
            // would be much more complicated, so just don't.
            val = _.reduce($el, function (memo, el) {
                let checkbox = Backbone.$(el);
                if (checkbox.prop('checked')) {
                    memo.push(checkbox.val());
                }
                return memo;
            }, []);
        }
        else {
            // Single checkbox bound to single model property.
            val = $el.prop('checked');
            let boxval = $el.val();
            if (boxval !== 'on' && boxval != null) {
                // This handles determining the proper return value if it's not
                // going to be a bool.
                val = val ? $el.val() : null;
            }
            // Setting button style.
            if (val) {
                $el.parent().addClass('btn-info');
            }
            else {
                $el.parent().removeClass('btn-info');
            }
        }
        return val;
    }
};

let radioButtonHandler = {
    // This handler is designed to work with stickit bindings for one or more
    // radio buttons using a common name attribute as the binding selector, and
    // which all bind to the same model property. Like so:
    // https://getbootstrap.com/docs/3.3/javascript/#buttons-checkbox-radio
    // This should be all we ever need, but if it turns out not to be, and we
    // need something like a set of radio buttons each with its own stickit
    // binding using an id selector, this code will need to be modified.
    selector: '[data-button-type="radio"]',
    update: function ($el, val, model, options) {
        $el.each(function (index, el) {
            if (el.value == val.toString()) {
                el.parentElement.classList.add('active');
                el.parentElement.classList.add('btn-info');
                el.checked = true;
            }
            else {
                el.parentElement.classList.remove('active');
                el.parentElement.classList.remove('btn-info');
                el.checked = false;
            }
        });
    },
    getVal: function ($el, event, options) {
        $el.not(':checked').each(function () {
            $(this).parent().removeClass('btn-info');
        });
        let selected = $el.filter(':checked');
        selected.parent().addClass('btn-info');
        return selected.val();
    }
};

Backbone.Stickit.addHandler(datePickerHandler);
Backbone.Stickit.addHandler(checkboxButtonHandler);
Backbone.Stickit.addHandler(radioButtonHandler);